// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Module
import { ClipboardModule } from 'ngx-clipboard';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { QualityRoutingModule } from './quality-routing.module';
import { AgGridModule } from 'ag-grid-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
//eslint-disable-next-line
import { ViewsModule } from '@cv-invision/cv.invision-views.ux';
// State
import { NgxsModule } from '@ngxs/store';
import { RulesState } from './rules/state/rules.state';
import { PhotoReviewState } from './photo-review/state/photo-review.state';
import { QualityState } from './state/quality.state';
import { QualityOrderDetailState } from './state/quality-order-detail.state';
import { VirtualTourState } from './virtual-tour/state/virtual-tour.state';
// Service
import { ComponentFactoryResolverService } from '@cv-invision/core';
import { DocumentLoaderGuard } from './service/document-loader.guard';
import { OverviewSubHeaderService } from './overview/sub-header/service/overview-sub-header.service';
// Component
import { OverviewComponent } from './overview/overview.component';
import { OverviewFieldsComponent } from './overview/scope/overview.fields';
import { PdfReviewComponent } from './pdf-review/pdf-review.component';
import { PhotoReviewComponent } from './photo-review/photo-review.component';
import { RuleComponent } from './rules/rule.component';
import { RulesComponent } from './rules/rules.component';
import { PhotoCardComponent } from './photo-review/photo-card/photo-card.component';
import { QualityComponent } from './quality.component';
import { OverviewSubHeaderComponent } from './overview/sub-header/overview-sub-header.component';
import { AvailablePdfComponent } from './overview/sub-header/available-pdf/available-pdf.component';
import { PhotoCardTabComponent } from './photo-review/photo-card/photo-card-tab-content.component';
import { PhotoContentDetailComponent } from './photo-review/photo-content-detail/photo-content-detail.component';
import { PhotoBaseContentComponent } from './photo-review/photo-card/photo-card-base-content.component';
import { PhotoContentSketchComponent } from './photo-review/photo-content-detail/photo-content-sketch/photo-content-sketch.component';
import { PhotoContentExteriorComponent } from './photo-review/photo-content-detail/photo-content-exterior/photo-content-exterior.component';
import { PhotoContentInteriorComponent } from './photo-review/photo-content-detail/photo-content-interior/photo-content-interior.component';
import { RuleCommentCreateComponent } from './rules/rule-comment/rule-comment-create.component';
import { RuleCommentStipViewComponent } from './rules/rule-comment-stip/rule-comment-stip-view.component';
import { RuleCreateComponent } from './rules/rule-create/rule-create.component';
import { RuleStipCreateComponent } from './rules/rule-stip/rule-stip-create.component';
import { RuleStipOptionComponent } from './rules/rule-stip/components/rule-stip-option.component';
import { RuleCommentStipViewItemComponent } from './rules/rule-comment-stip/rule-comment-stip-view-item.component';
import { RuleSetComponent } from './rules/rule-set/rule-set.component';
import { InReviewSectionsComponent } from './in-sections-review/in-review-sections/in-review-sections.component';
import { InReviewFieldsComponent } from './in-sections-review/in-review-fields/in-review-fields.component';
import { InReviewTablesComponent } from './in-sections-review/in-review-tables/in-review-tables.component';
import { InReviewStaticTablesComponent } from './in-sections-review/in-review-static-tables/in-review-static-tables.component';
import {
	InReviewTableColumnOptionsPipe,
	InReviewNestedTableOptionsPipe,
	InOnlyRealColumnsPipe,
} from './in-sections-review/in-review-tables/pipes/options.pipe';
import { InitialPageComponent } from './intial-page/initial-page.component';
import { RevisedFieldsComponent } from './revised-fields/revised-fields.component';
import { HistoricalValuesComponent } from './historical-values/historical-values.component';
import { CompGridComponent } from './1004/comp-grid/comp-grid.component';
import { PTableCompGridComponent } from './1004/comp-grid/p-table-comp-grid.component';
import { CustomPTableCompGridCellImageComponent } from './1004/comp-grid/custom-p-table-comp-grid-cell-image/custom-p-table-comp-grid-cell-image.component';
import { CustomPTableCompGridCellPublicRecordsComponent } from './1004/comp-grid/custom-p-table-comp-grid-cell-public-records/custom-p-table-comp-grid-cell-public-records.component';
import { CustomPTableCompGridCellComponent } from './1004/comp-grid/custom-p-table-comp-grid-cell/custom-p-table-comp-grid-cell.component';
import { CustomCompGridCellComponent } from './1004/comp-grid/custom-comp-grid-cell/custom-comp-grid-cell.component';
import { CustomCompGridCellImageComponent } from './1004/comp-grid/custom-comp-grid-cell-image/custom-comp-grid-cell-image.component';
import { CustomCompGridCellModalComponent } from './1004/comp-grid/custom-comp-grid-cell-modal/custom-comp-grid-cell-modal.component';
import { PublicRecordModalComponent } from './1004/comp-grid/modal/public-record-modal/public-record-modal.component';
import { CiPublicRecordListComponent } from './1004/comp-grid/modal/public-record-modal/components/ci-public-record-list/ci-public-record-list.component';
import { CiPublicRecordSingleFieldComponent } from './1004/comp-grid/modal/public-record-modal/components/ci-public-record-single-field/ci-public-record-single-field.component';
import { VirtualTourComponent } from './virtual-tour/virtual-tour.component';
import { CvdsStructuresComponent } from './cvds/cvds-structures/cvds-structures.component';
import { CvdsFieldComponent } from './cvds/cvds-structures/components/cvds-field/cvds-field.component';
import { CvdsFieldArrayComponent } from './cvds/cvds-structures/components/cvds-field-array/cvds-field-array.component';
import { CvdsPhotosComponent } from './cvds/cvds-photos/cvds-photos.component';
import { CvdsStructureComponent } from './cvds/cvds-structures/components/cvds-structure/cvds-structure.component';
import { CvdsUnitComponent } from './cvds/cvds-structures/components/cvds-unit/cvds-unit.component';
import { CvdsLevelComponent } from './cvds/cvds-structures/components/cvds-level/cvds-level.component';
import { CvdsRoomComponent } from './cvds/cvds-structures/components/cvds-room/cvds-room.component';
import { CvdsFieldTableComponent } from './cvds/cvds-structures/components/cvds-field-table/cvds-field-table.component';
import { CvdsCoolingSystemComponent } from './cvds/cvds-structures/components/cvds-cooling-system/cvds-cooling-system.component';
import { CvdsHeatingSystemComponent } from './cvds/cvds-structures/components/cvds-heating-system/cvds-heating-system.component';
import { RuleFeedbackComponent } from './rules/feedback/rule-feedback.component';
// Others
import { StripHTMLTagsPipe } from './overview/pipes/strip-html-tags.pipe';
import { PDFAttachmentsState } from './pdf-review/state/pdf-attachments.state';
import { RuleNotificationsComponent } from './rules/rule-notifications/rule-notifications.component';
import { RuleSectionLabel } from './rules/pipes/rule-section-label.pipe';
import { OrderRuleBy } from './rules/pipes/order-rule-by.pipe';
import { ApproveModalComponent } from './overview/sub-header/approve-modal/approve-modal.component';
import { UserIdleModule } from 'angular-user-idle';
import { StructureLess30YearsPipe } from './pipes/structure-less-30years.pipe';
import { IsArrayPipe } from './pipes/is-array.pipe';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import {
	ApproveRejectButtonsComponent
} from "./overview/sub-header/approve-reject-buttons/approve-reject-buttons.component";
import { UsersInfoComponent } from './overview/sub-header/users-info/users-info.component';
import { OrderInfoComponent } from './overview/sub-header/order-info/order-info.component';
import { DownloadButtonsComponent } from './overview/sub-header/download-buttons/download-buttons.component';
import { LockButtonComponent } from './overview/sub-header/lock-button/lock-button.component';

@NgModule({
	declarations: [
		RuleComponent,
		RuleFeedbackComponent,
		RulesComponent,
		RuleCreateComponent,
		RuleCommentCreateComponent,
		RuleCommentStipViewComponent,
		RuleCommentStipViewItemComponent,
		RuleStipCreateComponent,
		RuleStipOptionComponent,
		RuleSetComponent,
		PdfReviewComponent,
		PhotoReviewComponent,
		PhotoCardComponent,
		PhotoCardTabComponent,
		PhotoBaseContentComponent,
		PhotoContentDetailComponent,
		OverviewComponent,
		OverviewSubHeaderComponent,
		LockButtonComponent,
		AvailablePdfComponent,
		OverviewFieldsComponent,
		QualityComponent,
		PhotoContentSketchComponent,
		PhotoContentExteriorComponent,
		PhotoContentInteriorComponent,
		InitialPageComponent,
		InReviewFieldsComponent,
		InReviewTablesComponent,
		InReviewStaticTablesComponent,
		InReviewSectionsComponent,
		InReviewTableColumnOptionsPipe,
		InReviewNestedTableOptionsPipe,
		InOnlyRealColumnsPipe,
		CvdsStructuresComponent,
		RevisedFieldsComponent,
		HistoricalValuesComponent,
		CompGridComponent,
		PTableCompGridComponent,
		CustomPTableCompGridCellImageComponent,
		CustomPTableCompGridCellPublicRecordsComponent,
		CustomPTableCompGridCellComponent,
		CustomCompGridCellComponent,
		CustomCompGridCellImageComponent,
		CustomCompGridCellModalComponent,
		PublicRecordModalComponent,
		CiPublicRecordListComponent,
		CiPublicRecordSingleFieldComponent,
		StripHTMLTagsPipe,
		RuleNotificationsComponent,
		RuleSectionLabel,
		OrderRuleBy,
		VirtualTourComponent,
		ApproveModalComponent,
		CvdsFieldComponent,
		CvdsFieldArrayComponent,
		CvdsFieldTableComponent,
		CvdsPhotosComponent,
		CvdsStructuresComponent,
		CvdsStructureComponent,
		CvdsUnitComponent,
		CvdsCoolingSystemComponent,
		CvdsHeatingSystemComponent,
		CvdsLevelComponent,
		CvdsRoomComponent,
		// Pipes
		StructureLess30YearsPipe,
		IsArrayPipe,
		ApproveRejectButtonsComponent,
		OrderInfoComponent,
		DownloadButtonsComponent,
		UsersInfoComponent
	],
	entryComponents: [
		OverviewSubHeaderComponent,
		LockButtonComponent,
		AvailablePdfComponent,
		OverviewFieldsComponent,
		RulesComponent,
		PhotoCardTabComponent,
		PhotoBaseContentComponent,
		PhotoContentDetailComponent,
		InReviewFieldsComponent,
		InReviewTablesComponent,
		InReviewStaticTablesComponent,
		HistoricalValuesComponent,
		CompGridComponent,
		PTableCompGridComponent,
		CustomCompGridCellComponent,
		CustomCompGridCellImageComponent,
		ApproveModalComponent,
	],
	imports: [
		CommonModule,
		ClipboardModule,
		FormsModule,
		ReactiveFormsModule,
		ViewsModule,
		CvComponentLibraryModule,
		LazyLoadImageModule,
		NgxExtendedPdfViewerModule,
		InputTextareaModule,
		NgxsModule.forFeature([
			QualityState,
			QualityOrderDetailState,
			PhotoReviewState,
			RulesState,
			PDFAttachmentsState,
			VirtualTourState,
		]),
		QualityRoutingModule,
		AgGridModule.withComponents([]),
		NgbModule,
		UserIdleModule,
		TableModule,
		ButtonModule,
		InputTextModule,
		TooltipModule
	],
	providers: [
		ComponentFactoryResolverService,
		DocumentLoaderGuard,
		OverviewSubHeaderService
	],
})
export class QualityModule { }
